<template>
  <div v-if="dialog_status" id="dialog-wrapper">

    <loading :active.sync="busy"/>

    <div id="dialog-container"
      @keydown.esc="close()">
      <template>
        <div id="cards-wrapper">

          <!-- Header -->
          <div id="card-header">
            <!-- Menu bar -->
            <div id="card-header-menu">
              <div id="header-menu-title">도큐먼트 추가하기</div>
              <v-tooltip bottom small v-if="!small_screen">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="mode=0">
                    <v-icon color="primary" v-if="mode==0">mdi-alpha-s-box</v-icon>
                    <v-icon v-else>mdi-alpha-s-box</v-icon>
                  </v-btn>
                </template>
                <span>도큐먼트 검색하기</span>
              </v-tooltip>
              <v-tooltip bottom small v-if="!small_screen">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="mode=1">
                    <v-icon color="primary" v-if="mode==1">mdi-alpha-f-box</v-icon>
                    <v-icon v-else>mdi-alpha-f-box</v-icon>
                  </v-btn>
                </template>
                <span>도큐먼트 업로드하기</span>
              </v-tooltip>
              <v-tooltip bottom small v-if="!small_screen">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="mode=2">
                    <v-icon color="primary" v-if="mode==2">mdi-alpha-m-box</v-icon>
                    <v-icon v-else>mdi-alpha-m-box</v-icon>
                  </v-btn>
                </template>
                <span>도큐먼트 매뉴얼 입력하기</span>
              </v-tooltip>
              <v-btn class="close-icon" icon @click="close()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <div id="search-container" v-if="mode==0">
              <v-text-field v-model="query" filled dense rounded/>
              <v-btn @click="search(query)" icon><v-icon>mdi-magnify</v-icon></v-btn>
              <v-btn icon><v-icon>mdi-menu-down</v-icon></v-btn>
            </div>
            <div id="upload-container" v-if="mode==1">
              <div>복사&붙여넣기</div>
              <v-textarea filled dense rounded/>
            </div>
          </div>

          <!-- Contents -->
          <div id="card-contents" v-if="is_search">
            <!-- Left card -->
            <div id="left-card-wrapper" v-if="is_search">
              <div>
                <div id="left-card-list-header">검색결과 ({{ results.length }})</div>
                <div id="left-card-list-toolbar">
                  <v-checkbox></v-checkbox>
                  <v-icon>mdi-sort</v-icon>
                </div>
                <v-list>
                  <v-list-item-group v-model="selected_item">
                    <v-list-item class="left-card-list-content"
                    v-for="(doc, index) in results" :key="index">
                    <v-checkbox></v-checkbox>
                    <div>
                      <div class="card-title">{{ doc.title }}</div>
                      <div class="card-meta">
                        <div>{{ doc.authors_iso690}}</div>
                        <div>{{ doc.date }}</div>
                      </div>
                    </div>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </div>
            </div>

            <!-- Right card -->
            <div id="right-card-wrapper">
              <document-info v-if="selected_item!==null"></document-info>
              <div v-else id="empty-doc">
                리스트에서 도큐먼트를 선택해주세요.
              </div>
              <v-btn id="input-button" color="primary" dark fab>
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>

        </div>

      </template>
    </div>
  </div>
</template>

<script>
import { returnDocDetail } from '../../../custom/function'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      busy: false,
      mode: 0,
      query: "",
      raw_results: [],
      results: [],
      is_search: false,
      selected_item: null,
    }
  },

  computed: {
    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },
  },

  watch: {
    // query: {
    //   handler(val) {
    //     this.search(val)
    //   },
    // },

    selected_item: {
      async handler(val) {
        let selected_key = this.results[val].key
        await this.$store.dispatch('document/getDocument', selected_key)
      }
    }
  },

  methods: {
    returnDocDetail,

    close() {
      this.$emit('close')
      this.results = []
      this.is_search = false
      this.selected_item = null
    },

    search(query) {
      let query_obj = {}
      query_obj.title = this.reviseTitle(query)
      this.getResults(query_obj)
    },

    async getResults(query_obj) {
      let vm = this
      try {
        this.busy = true
        await this.$store.dispatch('input/getSuggestions', query_obj)
      } finally {
        vm.results = []
        this.raw_results = this.$store.getters['input/suggestions']

        if (!!this.raw_results.length) {
          this.raw_results.forEach(doc => {
            let result_doc = {}
            try {
              result_doc = vm.returnDocDetail(doc, doc.doc_type)
            } finally {
              vm.results.push(result_doc)
            }
          })
        }
        this.is_search = true
        this.busy = false
      }
    },

    reviseTitle(title) {
      var title_array = []
      var special_pattern = /[\"\';:\-]/gi

      title_array = [title.replace(special_pattern, ' ')
        .split(' ')
        .filter(v => v.trim()!="")
        .map(v => v.trim())]
        
      return title_array
    },

    reviseAuthors(authors) {
      if (Object.keys(authors[0]).includes('name_id')) {
        return null
      } else {
        var author_array = []
        for (let i=0; i<authors.length; i++) {
          let element = []
          let lastname = authors[i].lastname.trim()
          let firstname = authors[i].firstname.trim()
          if (!!lastname.length) { element.push(lastname) }
          if (!!firstname.length) { element.push(firstname) }
          if (!!element.length) { author_array.push(element) }
        }
        return author_array
      }
    },

    reviseYear(year) {
      var year_array = []
      var test_year = parseInt(year.trim())
      if (test_year.toString().length == 4) {
        year_array = [(test_year-1).toString(), test_year.toString(), (test_year+1).toString() ]
        if (test_year.toString() != year) {
          year_array.push(year)
        }
      } else { year_array = [year] }
      return year_array
    },
  },
}
</script>

<style scoped>

  #dialog-wrapper {
    height: 100vh;
    width: 100vw;
    background-color: rgba(33, 33, 33, 0.46);
  }

  #dialog-container {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #cards-wrapper {
    height: 100%;
    width: 100%;
  }

  #card-header, #left-card-wrapper, #right-card-wrapper {
    background-color: white;
  }

  #card-header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px 20px 0 20px;
    border-bottom: 1px solid #dde2e5;
  }

  #card-header-menu {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    font-size: 16px;
    font-weight: bold;
    color: #212528;
    margin-bottom: 20px;
  }

  .close-icon {
    margin-left: 12px;
  }

  #header-menu-title {
    margin-right: 12px;
    transform: translateY(6px);
  }

  #search-container {
    display: flex;
    flex-direction: row;
  }

  #upload-container {
    display: flex;
    flex-direction: row;
  }

  #card-contents {
    display: grid;
    grid-template-columns: 50% 50%;
  }

  #left-card-list-header {
    padding: 10px 20px;
    font-size: 16px;
    font-weight: bold;
    color: #323334;
    border-bottom: 1px solid #dde2e5;
  }

  #left-card-list-toolbar {
    padding: 10px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #dde2e5;
  }

  .left-card-list-content {
    padding: 10px 20px;
    display: flex;
    flex-direction: row;
  }

  .card-title {
    font-size: 14px;
    font-weight: 500;
    color: #323334;
  }

  .card-meta {
    font-size: 10px;
    font-weight: 500;
    color: #858d97;
  }

  #right-card-wrapper {
    border-left: 1px solid #dde2e5;
    position: relative;
  }

  #empty-doc {
    background-color: #fafafb;
    height: 100%;
    width: 100%;
    padding-top: 50px;
    color: #858d97;
    text-align: center;
    font-size: 24px;
  }

  #input-button {
    position: absolute;
    top: 20px;
    right: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/components/modal/input/AddDocs.vue